// Implements: F-IDN-017
/**
 * The file name of the personal-data export, as the v3 mockup names it: `mis-datos-<slug>.json`,
 * the slug being the name without accents, lower case, words joined by hyphens. A name with no
 * letter or digit left falls back to `mis-datos.json`.
 */

export function exportFileName(fullName: string): string {
  const slug = fullName
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return slug === "" ? "mis-datos.json" : `mis-datos-${slug}.json`;
}

/** The erasure is confirmed only by the exact e-mail, ignoring case and outer spaces. */
export function confirmsEmail(typed: string, email: string): boolean {
  return typed.trim().toLowerCase() === email.trim().toLowerCase();
}
